import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  // close mobile menu if user resizes to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) setIsOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // --- GOOGLE TRANSLATE BANNER HANDLER ---
  useEffect(() => {
    const body = document.body;

    const adjustNavbar = () => {
      const gtFrame = document.querySelector(".goog-te-banner-frame");
      if (gtFrame) {
        body.classList.add("gt-banner-visible");
      } else {
        body.classList.remove("gt-banner-visible");
      }
    };

    // MutationObserver for dynamic DOM changes
    const observer = new MutationObserver(adjustNavbar);
    observer.observe(body, { childList: true, subtree: true });

    // Also check periodically for safety
    const interval = setInterval(adjustNavbar, 300);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  return (
    <nav className="navbar">
      <h1 className="logo">Orange Home Interiors</h1>

      {/* Hamburger */}
      <button
        className={`hamburger ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen((s) => !s)}
        aria-label={isOpen ? "Close menu" : "Open menu"}
        aria-expanded={isOpen}
      >
        <span className="line" />
        <span className="line" />
        <span className="line" />
      </button>

      {/* Overlay */}
      <div
        className={`nav-overlay ${isOpen ? "show" : ""}`}
        onClick={closeMenu}
        aria-hidden={!isOpen}
      />

      {/* Nav Links */}
      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li>
          <NavLink to="/" onClick={closeMenu} className={({isActive}) => isActive ? "active-link" : ""}>Home</NavLink>
        </li>
        <li>
          <NavLink to="/products" onClick={closeMenu} className={({isActive}) => isActive ? "active-link" : ""}>Products</NavLink>
        </li>
        <li>
          <NavLink to="/services" onClick={closeMenu} className={({isActive}) => isActive ? "active-link" : ""}>Services</NavLink>
        </li>
        <li>
          <NavLink to="/projects" onClick={closeMenu} className={({isActive}) => isActive ? "active-link" : ""}>Projects</NavLink>
        </li>

        <li className="contact_us">
          <NavLink to="/aboutus" onClick={closeMenu} className={({isActive}) => isActive ? "active-link" : ""}>Contact Us</NavLink>
        </li>

        <li className="translate_li">
          <div id="google_translate_element"></div>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
